export const widgetsMock = {
    approvedAverage: 10,
    inProgressIndividualAverage: 40.55333,
    inactiveAverage: 50,
    completedAverage: 20,
    totalItems: 33
}

export const chartFiltersMock = {
    "users": [
        {
            "id": "10449510-db9f-4bba-ab2b-26fe256e2ff7",
            "name": "Franco Isla Massa",
            "lastActivity": "2024-12-11 20:37:20.65401+00"
        },
        {
            "id": "1265bab7-fdd3-4d4c-b75b-b0d875838a8e",
            "name": "Aydee Quispe",
            "lastActivity": "2025-01-30 18:19:06.005433+00"
        },
        {
            "id": "15a586ec-adb5-4e91-b8fc-c019b025e2a6",
            "name": "Sandra Almaguer",
            "lastActivity": null
        },
        {
            "id": "3b9f789c-df72-46c4-b78f-1ceb040be61d",
            "name": "Agustin Nicolas",
            "lastActivity": "2024-11-21 13:46:37.176091+00"
        },
        {
            "id": "3d76a8d9-9847-46de-bce2-a32163bcafd0",
            "name": "Franco Test",
            "lastActivity": null
        },
        {
            "id": "833c9611-78ec-473c-96a6-2c582d7af8cf",
            "name": "Christian David Leon Jimenez",
            "lastActivity": "2024-12-20 17:27:29.212446+00"
        },
        {
            "id": "9e8505a2-b012-44a3-ba8f-0e36eaec1305",
            "name": "Nicolas Marion",
            "lastActivity": "2024-10-29 21:57:00.517133+00"
        },
        {
            "id": "aa1ad70f-5dde-4fab-9ab5-f5d5e851d62e",
            "name": "Francisco sarmiento",
            "lastActivity": "2025-02-03 19:49:29.286582+00"
        },
        {
            "id": "af3eca37-d51f-490e-8744-0dd1e6ae096b",
            "name": "Rolando González",
            "lastActivity": "2025-01-22 18:33:01.932796+00"
        },
        {
            "id": "beab4793-8749-4841-8316-9bf1ff1ec64c",
            "name": "Franco Rocchia",
            "lastActivity": "2025-01-29 13:27:18.355342+00"
        },
        {
            "id": "f4705ec9-927e-449b-8c5f-add434600b0e",
            "name": "Jose Sleiter Rios",
            "lastActivity": null
        },
        {
            "id": "f777012b-31d9-4d0b-94ce-144a91327fb2",
            "name": "Bryan Key",
            "lastActivity": null
        }
    ],
    "courses": [
        {
            "id": "d0eeb98a-7e62-4cf2-8baf-201c72cd1eb7",
            "name": "3 de 7 hábitos de la gente altamente efectiva"
        },
        {
            "id": "cef67f73-4478-47bb-8257-911a2ac71f16",
            "name": "4 de 7 hábitos de la gente altamente efectiva"
        },
        {
            "id": "99ee07ec-e87a-4779-9028-94e5a6c0f670",
            "name": "Abastecimiento en la Cadena de Suministro"
        },
        {
            "id": "5c80de6c-3bc9-4780-b261-149e12a8515d",
            "name": "Acción ética"
        },
        {
            "id": "2620f26f-5d33-41be-9c56-f4b5d2c85545",
            "name": "Activación de desempeño: metodología OKR's"
        },
        {
            "id": "db43d589-51ee-4d08-b363-8e073b663505",
            "name": "Actividad Integradora - Administración de Talento y Capital Humano"
        },
        {
            "id": "2095d47e-f888-4127-ac88-5a23a636dbe7",
            "name": "Actividad integradora - Finanzas para no financieros"
        },
        {
            "id": "a81bcc70-8885-47fd-83c7-04c142c6c0c3",
            "name": "Actividad integradora - Logística y Cadena de Suministro"
        },
        {
            "id": "d96c65d3-b34c-47e7-9091-22dcd8049cb9",
            "name": "Actividad integradora - Organizaciones positivas"
        },
        {
            "id": "7c15d491-fa4a-43d8-a3e6-8061a6bce544",
            "name": "Actividad integradora - Power BI "
        },
        {
            "id": "44826370-2358-4ae9-bac8-471cf662a732",
            "name": "Actividad integradora - Ventas"
        },
        {
            "id": "3107c378-e44a-4a75-bf58-2269a998a252",
            "name": "Adaptabilidad al cambio"
        },
        {
            "id": "4e790503-830f-4862-9706-130ecd5f26dd",
            "name": "Adaptabilidad y flexibilidad en el trabajo"
        },
        {
            "id": "8e2c5c99-4266-4689-97ac-929168dc14c7",
            "name": "adawda"
        },
        {
            "id": "23dbbb75-ad2d-4e24-8d2b-bfb29f82e4fb",
            "name": " Administración del Proceso del Desarrollo Organizacional"
        },
        {
            "id": "b3a9f0a0-0cf0-4a1f-95e2-551cf5673644",
            "name": "Administración del Riesgo en los Transportes y Fundamentos de Inventarios"
        },
        {
            "id": "4f65e540-13ce-4576-95bc-48a46252106c",
            "name": "Administración escolar"
        },
        {
            "id": "45e22f69-994e-4be7-9b54-9b29b914de13",
            "name": "Administración financiera"
        },
        {
            "id": "feb1f758-cbda-4ddf-bbcc-5fea98e2dea6",
            "name": "adwda"
        },
        {
            "id": "d35dbdfb-fb7f-49c9-be81-edfa9d5a1826",
            "name": "Ambientes virtuales de aprendizaje"
        },
        {
            "id": "49a5e464-78c3-4b61-9ac5-e4d262b7f8f8",
            "name": "Ámbitos de la educación social"
        },
        {
            "id": "fa0b1bd1-1484-4ed4-a614-b24a54098a91",
            "name": "Amenaza 10. Incendio"
        },
        {
            "id": "28c2c0f2-75a5-44da-af0e-a750c400db30",
            "name": "Amenaza 14. Suicidio"
        },
        {
            "id": "3b9b608d-315a-405a-9e32-fd373f67b8e3",
            "name": "Amenaza 1. Accidente vehicular"
        },
        {
            "id": "b12d7484-02ad-4985-b1ce-684b1602c631",
            "name": "Amenaza 2. Amenaza de bomba"
        },
        {
            "id": "f9e37f63-1415-4aed-b812-f7cc7589cf13",
            "name": "Amenaza 3. Arma de fuego"
        },
        {
            "id": "088dd33a-ddc7-449b-8b6d-6ca7155a6bdf",
            "name": "Amenaza 4. Consumo de sustancias "
        },
        {
            "id": "51efbc53-35ab-4f16-bcbc-dca9849b4164",
            "name": "Amenaza 5. Deceso"
        },
        {
            "id": "fa72c107-0efc-4a78-82e1-50b8ecc60fa0",
            "name": "Amenaza 7. Explosión"
        },
        {
            "id": "7b11b873-f979-46a2-9763-991881844168",
            "name": "Análisis de datos en CRM: potencia tu estrategia comercial"
        },
        {
            "id": "d5467f66-7591-4cc8-bcb9-9363210953aa",
            "name": "Análisis de datos en ventas: impulsando el crecimiento empresarial"
        },
        {
            "id": "9f14c8e5-df16-4854-b94c-b7ea221d37aa",
            "name": "Análisis de datos financieros con machine learning"
        },
        {
            "id": "d9e71989-7fc6-4bfe-abb2-190bf0500764",
            "name": "Análisis de datos financieros y modelado"
        },
        {
            "id": "03755dd1-6510-4531-940c-dd42ad28d489",
            "name": "Análisis de datos para la automatización de marketing"
        },
        {
            "id": "00ff3f18-9537-43bf-b489-46729ef18bb4",
            "name": "Análisis de datos para tu estrategia de contenido: de los insights al impacto"
        },
        {
            "id": "f6e7b8cf-c739-499a-9312-2471b5d6fb68",
            "name": "Análisis de Impuestos: ISR, IVA"
        },
        {
            "id": "272fd8e0-2c59-4080-a222-608f473cd428",
            "name": "Análisis de información"
        },
        {
            "id": "da1d4461-88f5-409c-aa31-6945382e84e4",
            "name": "Análisis del presupuesto en Recursos Humanos"
        },
        {
            "id": "81864eb0-d4b3-4d81-a445-b095e603362a",
            "name": "Análisis de sistemas de medición MSA automotriz"
        },
        {
            "id": "225b38bb-845a-4a2e-a7fe-f20487a7fe8c",
            "name": "Análisis de situaciones para la toma de decisiones"
        },
        {
            "id": "6d1e0c03-af5f-4ec1-b9df-88db29170fbb",
            "name": "Análisis en las estrategias de ventas"
        },
        {
            "id": "9f51d1a9-9675-4159-af59-264576afa205",
            "name": "Análisis estratégico de mercado: un enfoque basado en datos"
        },
        {
            "id": "a892131a-ed6f-40e9-a921-9923b935ea0f",
            "name": "Análisis factorial"
        },
        {
            "id": "89ba4ab4-feba-4dd2-b6db-8ca46176d08f",
            "name": "Ansiedad y depresión en la era digital"
        },
        {
            "id": "9477bcef-6ef9-44aa-9b9b-16b368ae8ade",
            "name": "Aplicación práctica de la gestión de riesgos"
        },
        {
            "id": "0a810f69-c9f3-4498-9fdd-aceae1590420",
            "name": "Aprende Astronomía "
        },
        {
            "id": "000b7a6f-7f4d-451a-a5f0-48a557abbe13",
            "name": "Aprende Astronomía Básica "
        },
        {
            "id": "d74c8176-c1a4-407c-9570-5b542b2ebda2",
            "name": "Aprendiendo sobre felinos "
        },
        {
            "id": "35184d2d-5a00-4ff5-a3aa-e1cf6a09c4f7",
            "name": "Arquitectura de Hadoop"
        },
        {
            "id": "d66d6666-9575-46bb-9c14-a7e191d80c21",
            "name": "Arquitectura y Diseño de Software"
        },
        {
            "id": "74385a17-eecd-464b-819e-3f5c330d53e1",
            "name": "Aseguramiento de la Calidad"
        },
        {
            "id": "da9a358f-03ed-42a5-9812-ee207ea02730",
            "name": "Audio, texto y animación en Adobe Premiere Pro"
        },
        {
            "id": "21db80ca-06f7-4d3c-b407-96fecf77552a",
            "name": "Autoconocimiento e identidad positiva"
        },
        {
            "id": "aa650e89-7d1a-43bc-9bad-1d938518197a",
            "name": "Auto Save #06"
        },
        {
            "id": "8d28dc82-eba6-4f92-a670-a122d48ec125",
            "name": "Bases del inbound marketing: generación de leads"
        },
        {
            "id": "a6cc2130-62dd-4327-a950-9c9aa8d48d2e",
            "name": " Bases para aficionados y profesionales a la de electricidad y sistemas de control"
        },
        {
            "id": "e681396f-5cae-46d5-9569-0a4bc39eaca9",
            "name": "Bases y principios del Keyword Research"
        },
        {
            "id": "5ffb0472-7d10-4e91-8021-3461d5927efe",
            "name": "¿Bienestar o estar bien?"
        },
        {
            "id": "026c4287-1027-48e6-b473-227b3d5ed37b",
            "name": "¡Bienvenido a Lapzo!"
        },
        {
            "id": "187ab6af-b3e6-48e2-8152-4c3541debba4",
            "name": "¡Bienvenido a tu Plataforma de Desempeño! - Colaborador"
        },
        {
            "id": "e021982c-e7be-4414-be3a-ffa25473ae84",
            "name": "Calidad y eficiencia: Aplicando normas para optimizar procesos"
        },
        {
            "id": "8252223c-168f-4ffd-984c-c58aaafe7e84",
            "name": "calif pend 29 oct"
        },
        {
            "id": "b06991f8-2786-406e-9a34-09326653bdae",
            "name": "Campañas de publicidad pagadas"
        },
        {
            "id": "35efed22-7e9e-4118-9cf2-67a8a23740b3",
            "name": "Capacitación de CS y Sales"
        },
        {
            "id": "a8be9b88-7d08-46b0-98d1-ee6f969e48bf",
            "name": "Capacitación general para agentes TLG"
        },
        {
            "id": "f4383057-3bd0-4635-8dc9-ffff7353c31e",
            "name": "¿Cómo ser un buen Project Manager?"
        },
        {
            "id": "7abda686-fbb9-4d16-a1e5-23942912cfeb",
            "name": "Compraventa de Inmuebles"
        },
        {
            "id": "5a3a8e1c-4835-4dea-8097-adbf2eada99f",
            "name": "Comunicación directiva"
        },
        {
            "id": "902147ad-e5a7-4465-a5dd-eeb76358fc70",
            "name": "Comunicación efectiva"
        },
        {
            "id": "cc715422-74ed-4eb9-8339-a882db02f396",
            "name": "Comunicación efectiva para la resolución de conflictos en Recursos Humanos"
        },
        {
            "id": "afa1b226-a8ae-4d6e-a8b3-2b4bb93f2e0f",
            "name": "Comunicación estratégica"
        },
        {
            "id": "17b4fff5-fc4c-45ac-beb3-4d5839776cde",
            "name": "Confianza empresarial"
        },
        {
            "id": "7f806a3a-4801-4526-a815-efdeb6332452",
            "name": "Copia - Course Automation 757966"
        },
        {
            "id": "e71829c7-d949-4178-83e1-32a28072465f",
            "name": "Copia - curso con evaluación presencial"
        },
        {
            "id": "90305284-75a0-4a9b-bfa1-e262c83f4736",
            "name": "Copia - curso con evaluacion QA"
        },
        {
            "id": "0fe647f8-ccd4-4b6f-b52c-3f53d41205b2",
            "name": "Copia - Curso h4 Banco de preguntas #2"
        },
        {
            "id": "b6e9b398-08d1-4d33-b32a-0e62ac98211d",
            "name": "Copia - curso test miercoles noti #2"
        },
        {
            "id": "2e6f2574-6005-404b-9e36-efabc253834c",
            "name": "Copia - curso test miercoles noti #3"
        },
        {
            "id": "b3f4408e-1702-49ae-ae6c-13ac8c632240",
            "name": "Course Automation 100788"
        },
        {
            "id": "aef76ac2-9f2b-4a77-b59b-8a88b78a99ad",
            "name": "Course Automation 104589"
        },
        {
            "id": "aab9d943-8cb0-44d8-82c9-2900ca2c4161",
            "name": "Course Automation 130347"
        },
        {
            "id": "af1752ae-2520-4f1b-9f40-8316b3ec01dc",
            "name": "Course Automation 360741"
        },
        {
            "id": "465da41b-d867-4263-96e5-425fb13051d4",
            "name": "Course Automation 496780"
        },
        {
            "id": "10feb86d-9cd2-4a0f-988b-6aae704c24a5",
            "name": "Course Automation 504463"
        },
        {
            "id": "76209105-401d-4649-9599-36802d6128ea",
            "name": "Course Automation 944925"
        },
        {
            "id": "fd989f4f-8a2d-4116-a3e0-78a580ecd85d",
            "name": "Course e learning 1 para verificar inscripcion de LP"
        },
        {
            "id": "278b35cb-e035-47ab-a884-b4a96f60e9b2",
            "name": "cursito grupos prueba crear"
        },
        {
            "id": "6a9a4119-f862-497a-bdfb-f1408d7ffa70",
            "name": "cursito rubrica testeo"
        },
        {
            "id": "169f44ed-ceb1-4ed5-b7bb-322f84b0aada",
            "name": "Curso 060125"
        },
        {
            "id": "a9016b59-0b46-47d0-a276-dd5c07c69f0b",
            "name": "Curso 3000"
        },
        {
            "id": "dcbbfe4c-bf52-4852-9567-08c0ea952e5e",
            "name": "Curso 301"
        },
        {
            "id": "7cb9ff2c-82ef-4256-b0d9-1fceb9f68d6c",
            "name": "Curso base con todas las lessons calendarizado con zoom para verificar inscripciones por LPs 2"
        },
        {
            "id": "4e0eab2a-b997-41ac-8753-f847b1f08ee1",
            "name": "Curso bien hecho #01"
        },
        {
            "id": "04fb45e7-a76e-4f1d-8ecf-afb4272286d1",
            "name": "Curso bien hecho #02"
        },
        {
            "id": "68e30177-2336-4f1d-bac5-1a56d90034c3",
            "name": "Curso calendarizado con grupos publicos"
        },
        {
            "id": "7757cfe4-56af-4518-8a40-dea790f114b2",
            "name": "curso calendarizado verificar tipo de curso en reportes"
        },
        {
            "id": "6b7d97f3-648a-4135-86b8-7f7253ba382a",
            "name": "curso calificaciones rg"
        },
        {
            "id": "ec0793e8-0c3a-40b5-8b17-b52fefb4d66e",
            "name": "curso calificacion pendiente nikol"
        },
        {
            "id": "7d7ed22d-e805-43d7-a180-0e46e19b132c",
            "name": "curso con evaluacion"
        },
        {
            "id": "e7d4077e-c558-432b-955b-b3780cd67236",
            "name": "Curso con evaluaciones para Switch ACTIVO de mostrar respuestas mas de una vez"
        },
        {
            "id": "5ea893e5-12e0-4c2b-941a-4fd2be64326c",
            "name": "Curso con evaluaciones para Switch DESACTIVADO de mostrar respuestas mas de una vez"
        },
        {
            "id": "da83589b-58df-4eaa-8719-d0ff8fd7827f",
            "name": "curso con evaluacion QA"
        },
        {
            "id": "f053c4c1-fb6c-48d4-abfd-ddf2b9a5e5b4",
            "name": "Curso con evaluación - validar evaluación con todas las opciones iguales"
        },
        {
            "id": "c1543746-cc1c-4dec-ad34-5831c1194535",
            "name": "curso con grupo privado"
        },
        {
            "id": "6fc7cd9d-61ff-44e8-acef-0875324de9d9",
            "name": "curso con vencimiento consumible"
        },
        {
            "id": "584e0491-3122-4367-8745-2ee5969d474d",
            "name": "curso con vencimiento NO consumible"
        },
        {
            "id": "52cc74d2-446e-4e3a-9024-2749834c45ba",
            "name": "curso con videos "
        },
        {
            "id": "c65c9178-2a5e-4750-bf40-9ac808e63c95",
            "name": "Curso de Diseño Web Responsive con HTML y CSS por Franco Rocchia, La venganza, Esto es personal"
        },
        {
            "id": "61673a08-87f9-482e-b68e-9f4d772df189",
            "name": "curso de prueba nikol"
        },
        {
            "id": "0782d429-5a9c-4f07-a4cc-7fd988865642",
            "name": "curso de prueba para ticket 4851 test"
        },
        {
            "id": "196dcef4-034c-4591-9132-2eeaf6ee385a",
            "name": "Curso e-learning para verificar columnas de grupos en reportes"
        },
        {
            "id": "c6b6a270-53ca-4ae6-8b33-dce8f29b995c",
            "name": "curso e-learning verificar tipo de curso en reportes"
        },
        {
            "id": "6319a339-692e-4016-aaf3-3cc856d5f027",
            "name": "Curso Externo Gise"
        },
        {
            "id": "a8836ef0-50d5-4c35-9693-6fe56f6f3035",
            "name": "curso externo Test"
        },
        {
            "id": "15148259-ba3d-4eaa-8ed2-87d9f6c846e3",
            "name": "curso externo verificar tipo de curso en reportes"
        },
        {
            "id": "f177eb63-4ca7-4321-8996-d2894f65b828",
            "name": "Curso flujo completo modificar cursos"
        },
        {
            "id": "e84146a6-529a-48ca-afc0-fde9a8bcce3f",
            "name": "curso nikol HU6 RUBRICAS"
        },
        {
            "id": "76914b7b-6255-46eb-9c70-f61556f35636",
            "name": "Curso para banco #2"
        },
        {
            "id": "662fa252-0e64-4e0a-a71e-c181050bec45",
            "name": "Curso para la toma de LPs 1"
        },
        {
            "id": "47d30490-a7af-4f2e-9aec-e2a64eaca379",
            "name": "Curso para la toma de LPs 2"
        },
        {
            "id": "be659416-8a72-4066-9eb2-dfa307817f95",
            "name": "Curso para la toma de LPs 3"
        },
        {
            "id": "7d7a961a-08ca-4a41-90a0-330f9aeafec4",
            "name": "Curso para la toma de LPs 4"
        },
        {
            "id": "7ad94a48-9185-46d5-a071-45c5feb2d0dc",
            "name": "Curso para la toma de LPs con temporalidad dinamica 1"
        },
        {
            "id": "7d233c3c-1311-4bbd-8414-931f94ac97b1",
            "name": "Curso para la toma de LPs con temporalidad dinamica 11"
        },
        {
            "id": "85988045-52a9-4570-a37d-0f7bf7fadc56",
            "name": "Curso para la toma de LPs con temporalidad dinamica 12"
        },
        {
            "id": "dbd14f86-d103-4b77-90f1-b70dfb3bf665",
            "name": "Curso para la toma de LPs con temporalidad dinamica 14"
        },
        {
            "id": "0d481528-0390-420a-8404-ad1eca101f4d",
            "name": "Curso para la toma de LPs con temporalidad dinamica 15"
        },
        {
            "id": "1ee4c1d1-141b-4a62-bf6b-c168f0b14cbe",
            "name": "Curso para la toma de LPs con temporalidad dinamica 16"
        },
        {
            "id": "6b8c8529-110c-442e-a597-e1a11a5ac7b5",
            "name": "Curso para la toma de LPs con temporalidad dinamica 17"
        },
        {
            "id": "13c742ae-4fd2-46f9-9dc1-3120d2b4c09b",
            "name": "Curso para la toma de LPs con temporalidad dinamica 6"
        },
        {
            "id": "84ba7344-9591-41aa-960d-592f22367bc1",
            "name": "Curso para la toma de LPs con temporalidad dinamica 7"
        },
        {
            "id": "fcfca561-0941-4bee-8cb7-5ed25e28e56f",
            "name": "Curso para la toma de LPs con temporalidad dinamica 8 calendarizado"
        },
        {
            "id": "f9cf025d-0de4-4f3a-9c66-90a33fc9631d",
            "name": "Curso para la toma de un LP "
        },
        {
            "id": "aba63f41-3ecd-4560-a470-70a3af0b7383",
            "name": "Curso parámetro de; aprobación de Evaluaciones 2"
        },
        {
            "id": "542a41c6-b3d3-4b89-9dd3-54f622746086",
            "name": "Curso para notificación de finalización de cursos"
        },
        {
            "id": "df6115e6-7de1-4a57-b523-63393df6d745",
            "name": " Curso para notificación de inscripcion automatica"
        },
        {
            "id": "012ec0ae-8cf7-440e-bb8b-a7eaf1a5c408",
            "name": "curso pond"
        },
        {
            "id": "3cac51c5-7e40-4d14-805f-6d1a94aaff0b",
            "name": "Curso Prueba HU-1"
        },
        {
            "id": "3698c821-1d66-4532-b128-ed65692b0895",
            "name": "Curso Prueba II HU-6"
        },
        {
            "id": "1c3d3687-ae2f-4f8b-8979-13cc507ff9b4",
            "name": "curso prueba rubricas nikol HU"
        },
        {
            "id": "a2fe7172-206c-4f02-ac35-8b4f5c67a705",
            "name": "Curso regresión de asignación automática CYA-4179 -- 1"
        },
        {
            "id": "8269b2d1-67e1-4e4b-a2fb-2706471f0f8c",
            "name": "Curso regresión de asignación automática CYA-4179 -- 2"
        },
        {
            "id": "4fa9f565-0cb3-4904-8681-3d6b14df79f6",
            "name": "Curso regresión de asignación automática CYA-4179 -- 3"
        },
        {
            "id": "c13bc649-5047-497b-9830-75d275203f14",
            "name": " Curso regresión de asignación automática CYA-4179 -- 4"
        },
        {
            "id": "c1e27955-3292-44c1-b4b9-4a791b76df22",
            "name": "Curso regresión de asignación automática CYA-4179 -- 5"
        },
        {
            "id": "878db7d4-aa76-404b-a0b6-641e918ebe30",
            "name": "CURSOS CON GRUPOS PÚBLICOS"
        },
        {
            "id": "fce33584-7145-47ac-8b38-c7af803ba95a",
            "name": "Curso staging"
        },
        {
            "id": "04311f89-97f9-429b-97ff-8eb7c8f99efa",
            "name": "Curso test jueves g"
        },
        {
            "id": "f4dafeae-5d7f-46a6-a518-8610d55648a1",
            "name": "curso test miercoles noti #3"
        },
        {
            "id": "22938ba0-4d2d-4d18-88c9-542b97af4d29",
            "name": "Curso verificación de columna \"pertenece a lp\""
        },
        {
            "id": "25b558b2-340c-44a5-96e6-6d63588fa43d",
            "name": "curso verificar inscritos en reportes desde lps"
        },
        {
            "id": "7548c67f-6745-4f06-81af-e5752b2022bf",
            "name": " Deportes y su nutrición"
        },
        {
            "id": "1f2e1d11-acbb-4a97-83fe-291291b2abd1",
            "name": "Finish Lesson Test #05"
        },
        {
            "id": "3f242f46-c2c8-4039-a717-fd4daa195c63",
            "name": "Flujo de Certificaciones #01"
        },
        {
            "id": "4ff9e9b3-33b5-405d-974a-9f210c165ca1",
            "name": "Flujos Gise"
        },
        {
            "id": "9b9b6a41-0d23-4436-8c45-37cb0d168543",
            "name": "Forbidden Access #01"
        },
        {
            "id": "00de9320-6be8-41c8-8026-cfd93086acbf",
            "name": "Introducción a la norma NOM-035"
        },
        {
            "id": "88a357de-db76-4dcf-b1a7-05a0502d78d6",
            "name": "LP PROGRESO MÍNIMO"
        },
        {
            "id": "574489e9-c4c8-4e6a-975e-7364a06b278f",
            "name": "lp prueba 1 "
        },
        {
            "id": "48256bfc-5dfd-4fb7-9147-7443ec50a137",
            "name": "lp prueba 2"
        },
        {
            "id": "d186e302-ea70-4035-8b4e-d99e680efae5",
            "name": "lp prueba 3"
        },
        {
            "id": "d4a4cd3a-be6d-4eb1-9d8b-f604850d2ceb",
            "name": "lp prueba 4"
        },
        {
            "id": "208c8e0a-ed7a-4eef-802c-d2d3a2080402",
            "name": "lp prueba 5"
        },
        {
            "id": "9e921ad2-cee3-47fc-ba05-eca0d4aeadc2",
            "name": "lp prueba 6"
        },
        {
            "id": "00eb5f84-31b4-49c2-8c97-e27f7963af59",
            "name": "Microsoft Word"
        },
        {
            "id": "90c6e66c-3e47-4e15-ae18-c6b6105a9cae",
            "name": "nombre curso test"
        },
        {
            "id": "8baf2370-43df-4a20-8bb6-e50701aead3b",
            "name": "Nuevo curso con grupos para reportes"
        },
        {
            "id": "ef54a784-3593-4e3d-9aaa-112c967d6f3c",
            "name": "Nuevo curso con grupos test de nueva regla"
        },
        {
            "id": "d4eda3aa-b3df-4947-8242-2d75993a5aa1",
            "name": "Nuevo curso E-learning para la toma de lps"
        },
        {
            "id": "30c27f5f-8ec8-4223-999e-bae0e4d7cff6",
            "name": "nuevo curso en borrador #2"
        },
        {
            "id": "bd127b32-49a3-4951-8d43-7a98366b40de",
            "name": "Nuevo curso para testear la index en la toma"
        },
        {
            "id": "d11bda34-2c1c-4fae-99d9-2e79d889b012",
            "name": "Nuevo curso validar desinscripcion, E- learning"
        },
        {
            "id": "5a47ac43-f6e3-4353-85f0-4fc0da0378dc",
            "name": "pr"
        },
        {
            "id": "3910a8bd-5162-4a85-aef0-20b2fa87d596",
            "name": "prueba 4000"
        },
        {
            "id": "bd3b1c99-9529-428a-aab0-bba4b7c5552b",
            "name": "prueba clonando data"
        },
        {
            "id": "11b0be41-efd2-433e-bc40-fd3019c3f655",
            "name": "prueba consumible 2 "
        },
        {
            "id": "499e254c-7436-470a-bc17-c02cfd249441",
            "name": "Prueba de métodos de Inscripción E-learning 2"
        },
        {
            "id": "776ce0b0-f4cb-4a8a-8661-bb35d5352117",
            "name": "prueba demo nikol"
        },
        {
            "id": "e84992f9-9365-4a86-a840-fff8e7831640",
            "name": "Prueba Grupos"
        },
        {
            "id": "34231bb7-9269-4734-ab4f-78f05e6866d9",
            "name": "prueba nik 1234 cursos publicos y privados"
        },
        {
            "id": "c1b1316a-935f-472f-851e-36cddf9e5e32",
            "name": "prueba nikol "
        },
        {
            "id": "a00a7048-fe3f-4938-90af-624c9bacc40b",
            "name": "prueba nikol 3601"
        },
        {
            "id": "d34fee26-a888-472e-a71b-1552089780d0",
            "name": "prueba nikol 400000 2"
        },
        {
            "id": "d4809959-2fdd-4091-9421-be7355f40ae5",
            "name": "prueba online grupos"
        },
        {
            "id": "70ac8d1c-39ee-4f77-bce2-e1b6b538d403",
            "name": "prueba presencial y zoom"
        },
        {
            "id": "1d10e0e2-d00a-41c0-9e9f-e70bc12a5cec",
            "name": "Prueba privacidad calendarizado"
        },
        {
            "id": "3248152b-b419-41fc-9816-9ff5c11c37b0",
            "name": "prueba segmentacion nikol HU2"
        },
        {
            "id": "8ebc6264-6f0a-4a93-8cb2-6a54602132af",
            "name": "qa con evaluacion regresion"
        },
        {
            "id": "fc27b1ef-1ce8-4048-85a3-7a91889b1ffe",
            "name": "Rafael Rubricas Cuarto"
        },
        {
            "id": "e5708267-d34a-46fa-ba4e-d56f2c53c9c0",
            "name": "rafael rubricas SEGUNDO"
        },
        {
            "id": "65f9f228-564d-4025-89ae-f487b34fb0e4",
            "name": "rafael rubricas tercero"
        },
        {
            "id": "a25731c9-9453-4c8a-9c90-88813ad2b099",
            "name": "rafa sesiones presenciales"
        },
        {
            "id": "2891dea2-ba7e-44d9-86f6-d7ab483cd8b3",
            "name": "Responsiveness #02"
        },
        {
            "id": "ec449022-ace1-482d-ac09-4dbfabdd0954",
            "name": "Responsiveness #06"
        },
        {
            "id": "fabf6904-5719-4ae3-807f-bd68c7cffeec",
            "name": "Responsiveness #07"
        },
        {
            "id": "f9a581c9-36f0-4abe-a355-695b6cb8f5bf",
            "name": "Rich Text Test #01"
        },
        {
            "id": "b603d97b-488a-48de-b5fc-61ad4f3da9fe",
            "name": "rubricas rafael"
        },
        {
            "id": "974cdc0d-d1f9-4b30-9d1f-abe4ab0acdb6",
            "name": "Rubricas Rafael Cinco"
        },
        {
            "id": "86154e2d-fff7-478b-8a16-b1cd40437879",
            "name": "rubrics 22 oct"
        },
        {
            "id": "2a8cb66d-efdc-496c-8d94-fa8e052e39a5",
            "name": "Scorm Completion #01"
        },
        {
            "id": "85cadf31-523e-4eb0-926c-433d1282219f",
            "name": "test 100"
        },
        {
            "id": "384a8815-90c6-4774-a924-1eac6a3c7524",
            "name": "test 3871"
        },
        {
            "id": "84e51138-4f35-439c-9a52-521308135cf4",
            "name": "test course notif group follow up"
        },
        {
            "id": "a601e566-dd56-42f2-a27f-9fa1fc760f35",
            "name": "test curso recursos"
        },
        {
            "id": "31ed8363-68df-4e3d-8351-41baca2d0b8d",
            "name": "Test Joys"
        },
        {
            "id": "d215f06d-e4d5-4bbc-85a2-373413dbe0f6",
            "name": "test notif finalizacion curso"
        },
        {
            "id": "168f93ea-ccae-4ceb-94de-cb8122154d13",
            "name": "test notif fin de curso 2"
        },
        {
            "id": "cd2c57f5-cd20-4022-8149-6da555617bf3",
            "name": "Test ponderación Diego"
        },
        {
            "id": "cdfda173-3bcc-407c-9646-4d18695b8b4c",
            "name": "test Scrom"
        },
        {
            "id": "179ac58c-8c9e-4d19-a1d8-cd850b8584e5",
            "name": "test zoom"
        },
        {
            "id": "a0b09699-1154-41b5-a76b-131d8bbf615f",
            "name": "Translations #02"
        }
    ],
    "routes": [
        {
            "id": "fd23b660-8d3a-49dc-a312-6154ede63c5c",
            "name": "3258"
        },
        {
            "id": "2f7ff056-a397-40a2-8965-7b6ef614d1c5",
            "name": "4614 #01"
        },
        {
            "id": "328a05a2-500e-4a09-9e15-2052da354328",
            "name": "4614 #02"
        },
        {
            "id": "a0f8b2a9-9486-4072-8448-c23ea44f3038",
            "name": "4614 #03"
        },
        {
            "id": "31008bd5-b75c-43da-b39b-c2e49812088b",
            "name": "curso para probar asignacion automatica, a cursos y que no se inscriba a los calendarizados"
        },
        {
            "id": "43c7d6f0-bccf-4def-90cb-f213b92c275d",
            "name": "demo propiedades"
        },
        {
            "id": "55efce7c-020a-4405-8662-199949794cbd",
            "name": "Hola mundo"
        },
        {
            "id": "f7cd8efa-2f1e-40b0-8147-9764100a1806",
            "name": "inscripcion automatica a lps y cursos de lps 4605"
        },
        {
            "id": "33055b35-4885-42af-ab33-f3551e3475bc",
            "name": "kjnkjnkjn test"
        },
        {
            "id": "099f034b-eff8-40eb-83ae-128b8e41b957",
            "name": "Lorem #02"
        },
        {
            "id": "3ea539a6-775d-40e0-bf43-28071bc98508",
            "name": "LP 17 dec"
        },
        {
            "id": "52e1600a-7e27-470f-82ed-f2b4e54ac62d",
            "name": "Lp con inscripción; automática por OUs y Roles"
        },
        {
            "id": "27b79342-367d-45e6-8287-1cd76637cf7c",
            "name": "LP con temporalidad fija notificación 24 Horas antes del inicio"
        },
        {
            "id": "715ba05f-32d9-4bd6-b696-43cd2868cca2",
            "name": "LP con temporalidad Fija sin marcar el switch de reprobación tras fecha limite"
        },
        {
            "id": "48d9b095-4df3-41f0-a367-20930953a28c",
            "name": "LP curso para probar asignacion automatica a cursos y que no se inscriba a los calendarizados"
        },
        {
            "id": "16d22596-60b6-4af8-a708-7e3b4a72ee44",
            "name": "LP dinamico con dias para iniciar los cursos"
        },
        {
            "id": "5152d43f-9223-4530-9904-6261d08599cd",
            "name": "lp dinamico condicionado para ticket 4915"
        },
        {
            "id": "e863153b-1ba5-4e90-a3d0-49e627528211",
            "name": "lp dinamico para jobcito"
        },
        {
            "id": "08781fd7-fad5-421f-b76c-1f05f4e59ca7",
            "name": "LP para verificar columnas de grupos en reportes "
        },
        {
            "id": "c2794864-c0c2-4e88-b3c4-370d106ee162",
            "name": "LP regresión secciones sin cursos"
        },
        {
            "id": "8142a280-47a0-43e1-a31b-afdf13ed10d0",
            "name": "nikol 4378"
        },
        {
            "id": "9ebbf994-ce03-42aa-afb9-4a1d2935ea2d",
            "name": "nikol prueba 4110"
        },
        {
            "id": "0fa6c209-b9af-4852-ab3f-74360e2694a4",
            "name": "Nueva ruta con temporalidad x 1000"
        },
        {
            "id": "010aeeb4-7b31-4eac-acc6-5657a3225686",
            "name": "nueva ruta final test privada"
        },
        {
            "id": "f20d4776-a1ba-4c18-a666-3c32204a2101",
            "name": "Nueva ruta mixta validar que los usuarios puedan auto inscribirse a los calendarizados sin temporalidad"
        },
        {
            "id": "691f3bb6-213e-426b-be79-01a6c7090a52",
            "name": "Nueva ruta para filtro por rutas"
        },
        {
            "id": "568305cd-3dc9-4041-ae15-b102a186bf0d",
            "name": "Nueva ruta para notificacion de inscripción automatica"
        },
        {
            "id": "127d7435-568a-433d-84bd-4fb4411a0fe9",
            "name": "Nueva ruta para probar que se visualice en reportes"
        },
        {
            "id": "79512a18-2980-47a7-a9f0-ebdc0db8c2f5",
            "name": "Nueva ruta para reportes"
        },
        {
            "id": "0807655a-426e-4859-a234-ff754e82a873",
            "name": "Nueva ruta para verificar columna \"Conectado a lp\""
        },
        {
            "id": "3b02dcbd-2621-4205-90b6-2fb3b5da9cfb",
            "name": "Nueva ruta sin temporalidad"
        },
        {
            "id": "17a60c03-4646-4ac3-8782-e6a7adf34370",
            "name": "nueva ruta test nombre editado para reportes"
        },
        {
            "id": "09847443-10f2-4f76-ba2a-f85e93b5d76a",
            "name": "Nueva ruta x 5000 orem ipsum dolor sit amet, consectetur adipiscing elit. Fusce commodo hendrerit elit ac dapibus. Pellentesque quis arcu mauris. Aliquam iaculis quis nisi quis cursus. Nam dolor felis, hendrerit a enim nec, commodo condimentum nisi. "
        },
        {
            "id": "391ea136-5002-4973-bffd-3f54b1f219a7",
            "name": "Nuevo lp con temporalidad fija para verificar campo de fechas en reportes"
        },
        {
            "id": "2f2e5f10-d38a-434a-b15a-cfbe0050b8ae",
            "name": "nuevo LP con una temporalidad definida para verificar en reportes"
        },
        {
            "id": "036512db-7a17-49a1-98d1-b994afad72c9",
            "name": "progreso mínimo nombre editado"
        },
        {
            "id": "6562ff0d-98a5-4397-9f91-8a224a436fa8",
            "name": "prueba de inscripción "
        },
        {
            "id": "bf4b9594-4e26-468f-b615-07eb71bb482f",
            "name": "Prueba de ruta con temporalidad #01"
        },
        {
            "id": "c65f4e11-5f6d-4348-b46d-2de5ac5ad944",
            "name": "prueba fran"
        },
        {
            "id": "d94b2150-5fac-4b22-9d2a-7fc7ce78c835",
            "name": "prueba inscripcion"
        },
        {
            "id": "1678fc0d-507f-497a-9007-c1cd54d06cb1",
            "name": "prueba nikol propiedades 10"
        },
        {
            "id": "f9ac3c9b-df5f-4d9d-b8b6-0f8697aaecde",
            "name": "regresión de asignación automática CYA-4179 -- 1"
        },
        {
            "id": "aad7b3d5-3e6c-4076-9382-f00064421250",
            "name": "regresión de asignación automática CYA-4179 -- 2"
        },
        {
            "id": "d414797a-348f-4f8a-9493-e9c8dd8829c7",
            "name": "regresión de asignación automática CYA-4179 -- 3"
        },
        {
            "id": "a0f28cd5-7938-4ae6-b7d4-3ec42ca95410",
            "name": "regresión de asignación automática CYA-4179 -- 4"
        },
        {
            "id": "6e6d8b99-8b2d-48b2-9fa9-786fe4b60f7e",
            "name": "regresión de asignación automática CYA-4179 -- 5"
        },
        {
            "id": "cd968324-4619-4a2d-aae3-343e2aa05d0e",
            "name": "regresión de asignación automática CYA-4179 -- 6"
        },
        {
            "id": "37993bb8-2ef3-4626-a5ba-8d8428032e6f",
            "name": "Ruta con certificadores #03"
        },
        {
            "id": "25501d84-1097-4f6a-b673-cb3316148146",
            "name": "ruta con cursos consumibles"
        },
        {
            "id": "5063f551-7e80-4b5d-8f04-129cb1ec83d0",
            "name": "Ruta condicionada con cursos calendarizados y e learning 4606"
        },
        {
            "id": "1867835f-263c-4176-8231-33e4f2ef6ec0",
            "name": "Ruta condicionada para verificar redirección"
        },
        {
            "id": "304cc29e-9d77-463e-8127-eef0759ecda8",
            "name": "Ruta con Flujo de Certificadores #01"
        },
        {
            "id": "e1563268-665f-4dfb-b4f8-8667cec2881c",
            "name": "ruta con muchas personas inscritas "
        },
        {
            "id": "ce7d0d4a-9508-4838-9c0c-9f3fb246a208",
            "name": "ruta con muchas personas inscritas 2"
        },
        {
            "id": "07d455f4-2e02-42ed-85fc-fceda86810cb",
            "name": "Ruta con temporalidad dinamica HU1 --1"
        },
        {
            "id": "09fb7849-6ab3-471a-9945-88b27657e9e7",
            "name": "Ruta con temporalidad dinamica HU2 --1"
        },
        {
            "id": "d2953af2-f3c2-490e-aff7-65455fe9ea1b",
            "name": "Ruta con temporalidad dinamica para notificación 5 dias habiles antes de la terminacion"
        },
        {
            "id": "3bab7e5f-dc49-4ef9-b4b1-f7f0694692c9",
            "name": "Ruta con temporalidad dinamica para verificar notificación 24 horas antes de iniciar cursos"
        },
        {
            "id": "4221670e-95f4-4397-8b79-c86f81c41f42",
            "name": "Ruta con temporalidad dinamica para verificar notificación 24 horas antes de iniciar cursos ---4 notificaciones"
        },
        {
            "id": "cc82ac6e-7659-4fa3-b367-fd73d62d5895",
            "name": "Ruta con temporalidad dinamica para verificar que al no terminar el LP en los dias indicados, se marque  como reprobado"
        },
        {
            "id": "c3a83a27-f00a-411d-9e9e-64e4ef8482ae",
            "name": "ruta con temporalidad fija para notificacion 24 horas antes de inicio de cursos"
        },
        {
            "id": "1f15d9f7-bdac-4466-999f-10e369576176",
            "name": "Ruta con temporalidad fija para notificación 5 dias habiles antes de la terminacion"
        },
        {
            "id": "5e94a216-a196-40f7-b8f1-3e067d540c68",
            "name": "Ruta creada el 21/11/2024"
        },
        {
            "id": "8c25da78-21c4-408e-9a00-d33432994b89",
            "name": "Ruta de aprendizaje con temporalidad creada en team"
        },
        {
            "id": "f80b1122-6ec9-429c-ae44-54aafcd92989",
            "name": "Ruta de aprendizaje creada en team"
        },
        {
            "id": "4ee1d018-cf5b-4f0f-bfbe-a21c76ed5ff7",
            "name": "Ruta dinámica sin bloqueos de cursos para la toma "
        },
        {
            "id": "481be88c-0a0a-4589-918f-8220a5d3b068",
            "name": "Ruta Gise"
        },
        {
            "id": "07ec5012-a173-43a1-82a6-fc4d815b9475",
            "name": "ruta nueva con todos los usuarios inscritos con el curso curso verificar inscritos en reportes desde lps"
        },
        {
            "id": "8a03c4e3-b22b-4ad0-91f3-a3dceecf5d40",
            "name": "Ruta nueva staging"
        },
        {
            "id": "a00637dc-3312-426c-ab24-9ad553bfa063",
            "name": "Ruta para la toma en responsive"
        },
        {
            "id": "ff3bdbde-438a-4043-97cb-b9b16082a1a2",
            "name": "ruta para probar la toma x 6000"
        },
        {
            "id": "0ff6d8d5-c43a-402c-8e7e-248590de4a86",
            "name": "Ruta para regresión de inscripción automatica -- Desinscripción de usuarios"
        },
        {
            "id": "11736e30-50ce-42f6-9625-20016affe4cf",
            "name": "Ruta para reprobar"
        },
        {
            "id": "420f2329-aa55-4299-b72c-52238e605b4f",
            "name": "Ruta para reprobar y verificar criterio de aceptación "
        },
        {
            "id": "aca93e40-0356-4687-ad14-95ea005d063f",
            "name": "Ruta para ticket 4851"
        },
        {
            "id": "1182e44e-40b8-46f4-862e-933f50845b0e",
            "name": "Ruta para verificar inscripciones en LPs dinamicos HU1  -- 2"
        },
        {
            "id": "547ced0d-7236-4032-92e5-602f20b7b33a",
            "name": "Ruta para verificar inscripciones en LPs dinamicos HU1 -- 4"
        },
        {
            "id": "7577c593-ed58-4b54-ab5c-de59278e05d3",
            "name": "Ruta pública"
        },
        {
            "id": "db8bd976-e448-42d9-adca-4bcdc176abbc",
            "name": "Ruta test desinscripción "
        },
        {
            "id": "20c0c416-b4b8-4e49-ba74-73a3f2012c78",
            "name": "test"
        },
        {
            "id": "21a8c8ec-8feb-43b6-bec4-23fc31f1d7b3",
            "name": "Test Ch 01"
        },
        {
            "id": "6cefefae-4ec5-4143-a39d-47c4dc45403b",
            "name": "Test Ch 01"
        },
        {
            "id": "7f259048-a7e6-4f4e-8fe5-143ee1742fc1",
            "name": "Test Ch 01"
        },
        {
            "id": "01b17d01-a385-4247-be6e-cb605b421e48",
            "name": "test con roles y ous 2"
        },
        {
            "id": "b3746af3-9cc9-4f8e-815c-2e1cba86013a",
            "name": "test creacion con roles"
        },
        {
            "id": "0a39e6fe-a5d4-4be5-9446-e0866c6dc71f",
            "name": "test inscripcion de creacion"
        },
        {
            "id": "b771e3ad-8fd1-4d2f-8c9c-b9f1cea67343",
            "name": "test ins cursos en creacion"
        },
        {
            "id": "a300a003-7187-4c46-8b26-8231785471b2",
            "name": "test properties"
        },
        {
            "id": "ce6b59b3-2a1e-490f-8333-76b653be0adf",
            "name": "test properties 2"
        },
        {
            "id": "72a3ee28-655c-4979-a0e5-fe6b1908eed2",
            "name": "test prueba de inscripcion la rama pirata de vanessa y diego"
        },
        {
            "id": "07ba6098-c877-49d0-9ca3-f9ccbd728c20",
            "name": "validar el 3842 ruta con temporalidad"
        }
    ]
}

export const donutChartMock = {
    "approvedAverage": 9,
    "inProgressAverage": 5,
    "failedAverage": 0,
    "inactiveAverage": 86,
    "totalItems": 263
}

function getRandomInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const maxTotalApproved = getRandomInt(0, 200);
const maxTotalInProgress = getRandomInt(0, 200);
const maxTotalFailed = getRandomInt(0, 200);
const maxTotalInactive = getRandomInt(0, 200);

export const barsChartMock = [
    {
        userId: "10449510-db9f-4bba-ab2b-26fe256e2ff7",
        userName: "Franco Isla Massa",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "1265bab7-fdd3-4d4c-b75b-b0d875838a8e",
        userName: "Aydee Quispe",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "15a586ec-adb5-4e91-b8fc-c019b025e2a6",
        userName: "Sandra Almaguer",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "3b9f789c-df72-46c4-b78f-1ceb040be61d",
        userName: "Agustin Nicolas",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "3d76a8d9-9847-46de-bce2-a32163bcafd0",
        userName: "Franco Test",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "833c9611-78ec-473c-96a6-2c582d7af8cf",
        userName: "Christian David Leon Jimenez",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "9e8505a2-b012-44a3-ba8f-0e36eaec1305",
        userName: "Nicolas Marion",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "aa1ad70f-5dde-4fab-9ab5-f5d5e851d62e",
        userName: "Francisco sarmiento",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "af3eca37-d51f-490e-8744-0dd1e6ae096b",
        userName: "Rolando González",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "beab4793-8749-4841-8316-9bf1ff1ec64c",
        userName: "Franco Rocchia",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "f4705ec9-927e-449b-8c5f-add434600b0e",
        userName: "Jose Sleiter Rios",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    },
    {
        userId: "f777012b-31d9-4d0b-94ce-144a91327fb2",
        userName: "Bryan Key",
        totalApproved: getRandomInt(0, maxTotalApproved),
        totalInProgress: getRandomInt(0, maxTotalInProgress),
        totalFailed: getRandomInt(0, maxTotalFailed),
        totalInactive: getRandomInt(0, maxTotalInactive)
    }
];

export const courseDrawerMock = {
    "courseId": "e84146a6-529a-48ca-afc0-fde9a8bcce3f",
    "courseName": "curso nikol HU6 RUBRICAS",
    "startDate": "2024-11-21T13:46:37.963Z",
    "endDate": null,
    "contentType": "COURSE",
    "courseType": "E-LEARNING",
    "totalProgress": 10,
    "status": "IN_PROGRESS",
    "totalLessons": 19,
    "modules": [
        {
            "lessons": [
                {
                    "lessonId": "8388041c-0cd1-4017-9d6e-bfb75e90379a",
                    "lessonName": "Evaluación presencial calificación manual",
                    "isCompleted": false
                },
                {
                    "lessonId": "2a822cee-3899-4419-b11f-03e422006593",
                    "lessonName": "Evaluación presencial calificación automática",
                    "isCompleted": false
                },
                {
                    "lessonId": "1a9015fc-fc49-4946-b519-fcb2ead03a84",
                    "lessonName": "Foro",
                    "isCompleted": false
                },
                {
                    "lessonId": "63d6b440-7f7a-4539-954b-ac3c7bb325f9",
                    "lessonName": "Tarea",
                    "isCompleted": false
                },
                {
                    "lessonId": "ced6fb0c-385b-4030-a8e3-5d2bfbd2eced",
                    "lessonName": "Tarea",
                    "isCompleted": false
                },
                {
                    "lessonId": "6a8e483c-bf67-4649-b0ef-b80f0a0de7f4",
                    "lessonName": "Foro",
                    "isCompleted": false
                },
                {
                    "lessonId": "ce58febb-2433-45ba-8742-ce406dc4ae9f",
                    "lessonName": "EV RUBRICAS",
                    "isCompleted": false
                },
                {
                    "lessonId": "86744020-ead6-4648-88bf-e035e9ed3922",
                    "lessonName": "evaluacion presencial",
                    "isCompleted": true
                },
                {
                    "lessonId": "85f9fd05-c760-4105-8f3e-b582173a23bd",
                    "lessonName": "Foro Vane",
                    "isCompleted": false
                },
                {
                    "lessonId": "d21dde4a-933e-4582-b384-ec0628ef0126",
                    "lessonName": "Tarea",
                    "isCompleted": false
                },
                {
                    "lessonId": "fc0ffa46-a836-4a31-8ffb-a0f138c76da4",
                    "lessonName": "Evaluación presencial",
                    "isCompleted": false
                }
            ],
            "moduleId": "56757b52-c792-45bc-aa37-6a803054ce83",
            "moduleName": "Módulo 1"
        },
        {
            "lessons": [
                {
                    "lessonId": "8388041c-0cd1-4017-9d6e-bfb75e90379a",
                    "lessonName": "Evaluación presencial calificación manual",
                    "isCompleted": false
                },
                {
                    "lessonId": "2a822cee-3899-4419-b11f-03e422006593",
                    "lessonName": "Evaluación presencial calificación automática",
                    "isCompleted": false
                },
                {
                    "lessonId": "1a9015fc-fc49-4946-b519-fcb2ead03a84",
                    "lessonName": "Foro",
                    "isCompleted": false
                },
            ],
            "moduleId": "56757b52-c792-45bc-aa37-6a803054ce83",
            "moduleName": "Módulo 2"
        },
        {
            "lessons": [
                {
                    "lessonId": "ce58febb-2433-45ba-8742-ce406dc4ae9f",
                    "lessonName": "EV RUBRICAS",
                    "isCompleted": false
                },
                {
                    "lessonId": "86744020-ead6-4648-88bf-e035e9ed3922",
                    "lessonName": "evaluacion presencial",
                    "isCompleted": true
                },
                {
                    "lessonId": "85f9fd05-c760-4105-8f3e-b582173a23bd",
                    "lessonName": "Foro Vane",
                    "isCompleted": false
                },
                {
                    "lessonId": "d21dde4a-933e-4582-b384-ec0628ef0126",
                    "lessonName": "Tarea",
                    "isCompleted": false
                },
                {
                    "lessonId": "fc0ffa46-a836-4a31-8ffb-a0f138c76da4",
                    "lessonName": "Evaluación presencial",
                    "isCompleted": false
                }
            ],
            "moduleId": "56757b52-c792-45bc-aa37-6a803054ce83",
            "moduleName": "Módulo 3"
        }
    ]
}
